module.exports = __webpack_public_path__ + "static/media/ondeck-legal.edb3b39a.jpg";